<template>
  <van-empty class="custom-image" :image="require('@/assets/imgs/common/暂无数据@2x.png')" :description="description">
    <slot name="default"></slot>
  </van-empty>
</template>
<script>
export default {
  props: ['description']
};
</script>

<style lang="less">
.custom-image {
  height: 100%;
  width: 100%;
  background: #f5f5f5;
  .van-empty__image {
    width: 176px;
    height: 176px;
  }
}
</style>
